/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-debugger */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';

import NewsInfo from 'src/app/components/NewsInfoComponent/NewsInfo';
import { UrlInfoResultType } from 'src/app/services/dfm-service/dfm.service.type';
import { BlockResultType } from 'src/app/services/surfer-service/surfer.service.type';
import { dfmAxios } from 'src/app/utils/axios.instance';

export type PropsType = {
  hasText?: boolean;
  blockData: BlockResultType;
};

// This component take block data as prop and decrypt it. Then pass it to News Info Component
const DataViewer: React.FC<PropsType> = ({ hasText, blockData }) => {
  const [fileContent, setFileContent] = useState<UrlInfoResultType>();

  /*
  This function get block id as parameter
  Then it decrypts that block data.
  .txt query gives metadata
  */
  const getData = async (id: string) => {
    let metadata: any;
    try {
      const { data } = await dfmAxios.get(`${id}.txt`, { blockSpinner: true });
      metadata = data;
    } catch (error) {
      console.log('error', error);
    }

    setFileContent({ ...metadata });
  };

  useEffect(() => {
    if (blockData) {
      getData(blockData.metadata.id);
    }
  }, [blockData]);

  if (!fileContent) return null;
  return (
    <div>
      <NewsInfo getFileContent={fileContent} hasText={hasText} blockData={blockData} />
    </div>
  );
};

export default DataViewer;
